import { getActiveChain, getChains, selectChain } from "../lib/chainSelect";

/**
 * The network the site talks to. One gateway per chain behind nginx; picking
 * another reloads into it (sessions and orders belong to a gateway). Hidden
 * on a single-chain deployment — a select with one option is noise.
 */
export function ChainSwitch() {
  const chains = getChains();
  if (chains.length < 2) return null;
  const active = getActiveChain();
  return (
    <label className="chain-switch">
      <span className="sr-only">Network</span>
      <select
        className="chain-switch-select"
        aria-label="Network"
        value={active.key}
        onChange={(e) => selectChain(e.target.value)}
      >
        {chains.map((c) => (
          <option key={c.key} value={c.key}>
            {c.label}
          </option>
        ))}
      </select>
    </label>
  );
}
